import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../lib/utils";

/**
 * Shared brand mark + wordmark. Always links to the marketing landing (`/`).
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
export function BrandLogo({ className }) {
  return (
    <Link
      to="/"
      aria-label="Assembly Platform"
      className={cn(
        "flex shrink-0 items-center gap-2.5 no-underline",
        className
      )}
    >
      <img
        src="/images/logo_main.png"
        alt=""
        className="h-7 w-7 shrink-0 rounded-md"
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
      <span className="hidden min-w-0 truncate font-display text-base font-medium text-text-primary md:inline md:text-lg">
        Assembly{" "}
        <span className="font-normal text-text-secondary">Platform</span>
      </span>
    </Link>
  );
}
